import { CheckIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { Toaster as SonnerToaster, toast } from 'sonner';

type ToasterProps = React.ComponentProps<typeof SonnerToaster>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <SonnerToaster
      className="toaster group"
      icons={{
        success: <CheckIcon className="h-4 w-4 text-green-600" />,
        error: <XCircleIcon className="h-4 w-4 text-red-600" />,
      }}
      toastOptions={{
        classNames: {
          toast: 'group toast group-[.toaster]:shadow-lg',
          icon: 'group-[.toast]:!h-5',
          description: 'group-[.toast]:text-text-inverse-secondary',
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
